import { Avatar, Box, Checkbox } from "@mui/material"
import { NoResult } from "../../../../../empty/Index"
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
const icon = <CheckBoxOutlineBlank fontSize="small" sx={{color: '#C2C2C2', borderRadius: '4px'}} />;
const checkedIcon = <CheckBox fontSize="small" sx={{color: '#333333', borderRadius: '4px'}} />;

export const UserList = ({ulistAccess, setSlctTxt, searchData, setSearchData, searchInput, usrData, setUsrData}) => {

    const handleSelectUser = (e, id) => {
        let data = ulistAccess.data.map((v) => v.id === id ? {...v, stat : {...v.stat, remove:e.target.checked} } : {...v})
        setSlctTxt(data.filter(v => { return !v.stat.remove }  ).length > 0 ? false : true)
        ulistAccess.set(data)
        setUsrData({...usrData, users: usrData.users.map((v) => v.id === id ? {...v, stat : {...v.stat, remove:e.target.checked} } : {...v}) })
        if (searchInput.data !== '') {
            setSearchData(searchData.map((v) => v.id === id ? {...v, stat : {...v.stat, remove:e.target.checked} } : {...v}))
        }
    }
    
    return (
        (searchInput.data !== '' && searchData.length === 0) || ulistAccess.data.length === 0 ?
            <NoResult />
        :
            (searchInput.data !== '' ? searchData : ulistAccess.data).map((v,k) => (
                <Box display="flex" alignItems="center" gap="24px" mt="12px" key={k}>
                    <Checkbox onChange={(e)=>handleSelectUser(e, v.id)} checked={v.stat.remove} icon={icon} checkedIcon={checkedIcon} sx={{p: '0px'}} />
                    <Box display="flex" alignItems="center" gap="12px">
                        <Avatar src={JSON.parse(v.profile).profile} alt="profile_img" sx={{width: 32, height: 32}} />
                        <Box display="flex" flexDirection="column" fontWeight={400} lineHeight="24px">
                            <Box fontSize={14} >{v.first_name} {v.last_name}</Box>
                            <Box fontSize={12} color="#A2A3A9">
                                {
                                    v.stat.update === false && v.stat.download === false ?
                                        'View'
                                    :
                                        v.stat.update && v.stat.download ?
                                            'Update & Download'
                                        :
                                            v.stat.update === false && v.stat.download ?
                                                'View & Download'
                                            :
                                                'View & Update'
                                }
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ))
    )
}
